var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, Fragment } from 'react';
import * as styles from './search-dropdown.styles';
import { Menu, Transition } from '@headlessui/react';
import { classNames } from '../../../utils/style-class.utils';
import { Typography } from '../../typography/typography';
import { renderIcon } from '../../../utils/icon-utils';
export function SearchDropDown(_a) {
    var id = _a.id, placeholder = _a.placeholder, label = _a.label, disabled = _a.disabled, options = _a.options, pluralSelectionText = _a.pluralSelectionText, info = _a.info, multiple = _a.multiple, _b = _a.selectedOptions, selectedOptions = _b === void 0 ? [] : _b, onChange = _a.onChange, className = _a.className, displayMenuOverlay = _a.displayMenuOverlay, menuItemClassName = _a.menuItemClassName, menuItemStyle = _a.menuItemStyle, overlayTopOffset = _a.overlayTopOffset, _c = _a.color, color = _c === void 0 ? 'primary' : _c, _d = _a.bgColor, bgColor = _d === void 0 ? 'white' : _d, _e = _a.isFullWidth, isFullWidth = _e === void 0 ? true : _e, preventCloseOnClick = _a.preventCloseOnClick;
    var _f = useState(''), selectedLabel = _f[0], setSelectedLabel = _f[1];
    var _g = useState(false), touched = _g[0], setTouched = _g[1];
    var _h = useState(false), isOpen = _h[0], setIsOpen = _h[1];
    var isOptionSelected = function (option) {
        var isInSelectedItems = selectedOptions.some(function (selectedOption) {
            return selectedOption.id === option.id;
        });
        return isInSelectedItems;
    };
    var updateSelectedLabel = function (currentSelectedIds, options) {
        if (currentSelectedIds.length > 1) {
            setSelectedLabel("".concat(currentSelectedIds.length, " ").concat(pluralSelectionText || 'Selected'));
        }
        else if (currentSelectedIds.length === 1) {
            var label_1 = selectedLabel;
            if (currentSelectedIds.length > 0) {
                var selectedOption = options.find(function (option) { return option.id === currentSelectedIds[0].id; });
                label_1 = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || placeholder || '';
            }
            setSelectedLabel(label_1);
        }
        else {
            setSelectedLabel(placeholder || '');
        }
    };
    var optionClicked = function (event, option) {
        event.stopPropagation();
        if (option.disabled)
            return;
        if (!touched) {
            setTouched(true);
        }
        var optionSelected = isOptionSelected(option);
        var newSelection = multiple
            ? handleMutlipleItemSelection(option, optionSelected)
            : handleSingleItemSelection(option, optionSelected);
        onChange && onChange(newSelection);
    };
    var handleMutlipleItemSelection = function (option, selected) {
        var newSelectedOptions = __spreadArray([], selectedOptions, true);
        if (selected) {
            var indexOf = newSelectedOptions.findIndex(function (x) { return x.id === option.id; });
            newSelectedOptions.splice(indexOf, 1);
        }
        else {
            newSelectedOptions.push(option);
        }
        updateSelectedLabel(newSelectedOptions, options);
        return newSelectedOptions;
    };
    var handleSingleItemSelection = function (option, selected) {
        if (selected) {
            setSelectedLabel('');
            return [];
        }
        setSelectedLabel(option.label);
        return [option];
    };
    var hasSelectedValue = function () {
        return selectedOptions.length > 0;
    };
    useEffect(function () {
        if (selectedOptions.length > 0) {
            setTouched(true);
        }
        updateSelectedLabel(selectedOptions, options);
    }, [options, selectedOptions]);
    return (_jsxs("div", __assign({ className: className }, { children: [label && _jsx("label", __assign({ className: styles.label }, { children: label })), _jsx(Menu, __assign({ as: "div", className: isFullWidth ? 'w-full' : '' }, { children: function (_a) {
                    var open = _a.open;
                    return (_jsxs(_Fragment, { children: [_jsxs(Menu.Button, __assign({ id: id, className: classNames(className, styles.getButtonStyles(color, bgColor, open, hasSelectedValue(), touched)), disabled: disabled, onClick: function () {
                                    return isOpen === false ? setIsOpen(true) : setIsOpen(false);
                                } }, { children: [_jsx(Typography, { type: 'help', color: open || !hasSelectedValue() || !touched
                                            ? 'textLight'
                                            : 'white', text: selectedLabel || placeholder || '' }), renderIcon(!open ? 'ChevronDownIcon' : 'ChevronUpIcon', styles.getButtonIcon('primary', open, hasSelectedValue()))] })), _jsx(Transition, __assign({ show: preventCloseOnClick ? isOpen : open, as: Fragment, enter: styles.enter, enterFrom: styles.enterFrom, enterTo: styles.enterTo, leave: styles.leave, leaveFrom: styles.leaveFrom, leaveTo: styles.leaveTo }, { children: _jsx("div", __assign({ className: displayMenuOverlay ? styles.overlay(overlayTopOffset) : '', onClick: preventCloseOnClick
                                        ? function (prevState) { return setIsOpen(!prevState); }
                                        : undefined }, { children: _jsxs(Menu.Items, __assign({ className: classNames(styles.menuItems, menuItemClassName, displayMenuOverlay ? 'absolute' : ''), style: __assign({}, menuItemStyle) }, { children: [info && (_jsxs("div", __assign({ className: styles.infoWrapper }, { children: [info.name && (_jsx(Typography, { type: "body", color: 'textDark', text: info.name })), info.hint && (_jsx(Typography, { type: "help", color: 'textMid', text: info.hint || '' }))] }))), options &&
                                                options.map(function (item, index) {
                                                    var optionSelected = isOptionSelected(item);
                                                    return (_jsx(Menu.Item, __assign({ as: "div", onClick: function (event) {
                                                            return optionClicked(event, item);
                                                        } }, { children: _jsxs("div", __assign({ className: styles.menuItem }, { children: [renderIcon('CheckCircleIcon', styles.getDropDownIcon(color, optionSelected)), _jsx(Typography, { type: 'body', text: item.label, color: optionSelected ? 'textDark' : 'textMid' })] })) }), "drop-down-menu-item-".concat(index)));
                                                })] })) })) }))] }));
                } }))] })));
}
export default SearchDropDown;
//# sourceMappingURL=search-dropdown.js.map